import styled, { css } from "styled-components/macro";
import { layout, LayoutProps } from "styled-system";
import { mediaMin } from "styles/media";

export const Sticky = styled.div`
  position: sticky;
  top: 0;
  height: 100vh;
  padding: 24% 0;

  ${mediaMin.xs`
    padding: 48px 0;
  `}
`;

export const VideoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: calc(40vh);

  ${mediaMin.xs`
    margin-bottom: 40px;
    height: calc(100vh - 336px);
  `}
`;

export const VideoWrapper = styled.div<LayoutProps>`
  overflow: hidden;
  border-radius: 7px;
  border: solid 4px black;
  ${layout};

  ${mediaMin.xs`
    margin-bottom: 56px;
  `}

  ${mediaMin.md`
    margin-bottom: 64px;
  `}
`;

export const Video = styled.video<{ $shouldVisible: boolean }>`
  width: 100%;
  height: 100%;
  display: none;
  object-fit: fill;
  transform: scale(1.001); // 영상 가장자리 흰 공간을 없애기 위한 처리
  border-radius: 3px;

  ${({ $shouldVisible }) =>
    $shouldVisible &&
    css`
      display: block;
    `}
`;
